import FormError from "./FormError.tsx";
import {Logo} from "../../components/specific/Logo.tsx";
import {useRef, useState} from "react";
import {UnauthenticatedBackendApi} from "../../api/UnauthenticatedApi.ts";
import LoadingFrame from "../../components/LoadingFrame.tsx";

export default function PasswordResetPage() {
    const unauthenticatedApi = new UnauthenticatedBackendApi()

    const emailInputElement = useRef<HTMLInputElement>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [formError, setFormError] = useState<string>('')


    return (


        <div className='w-96 mx-auto mt-48'>
            <div className="mb-16">
                <Logo/>

            </div>
            <LoadingFrame isLoading={isLoading}>
                <h1 className="mt-8 text-3xl font-bold leading-9 tracking-tight text-gray-900 mt-24 md:mt-2">Wachtwoord
                    vergeten?</h1>
                <h2 className='mt-2 text-xl tracking-tight text-primary md:mt-2'>Geen probleem!</h2>
                <p className="mt-8 text-sm text-gray-600 mb-8">Vertel ons je e-mailadres, zodat we je een link kunnen
                    sturen
                    om je wachtwoord te resetten</p>
                <form action="#" method="POST" className="space-y-6" onSubmit={(e) => {
                    e.preventDefault()
                    setIsLoading(true)
                    unauthenticatedApi.Public__sendResetPasswordEmail({
                        user_email: emailInputElement.current.value
                    }).then(() => {
                        window.location.replace('/reset-password-success')
                    }).catch((err) => {
                        setIsLoading(false)
                        setFormError(err.message)
                    })
                }}>
                    <div>
                        <label htmlFor="email"
                               className="block text-sm font-medium leading-6 text-gray-900">
                            E-mailadres
                        </label>
                        <div className="mt-2">
                            <input
                                id="email"
                                ref={emailInputElement}
                                name="email"
                                type="email"
                                required
                                autoComplete="email"
                                className="px-2 block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>
                    {formError && <FormError message={formError}/>}
                    <div>
                        <button
                            type="submit"
                            className="flex w-full justify-center rounded-md bg-primary px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-primary hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                        >
                            Reset link sturen
                        </button>
                    </div>
                </form>
            </LoadingFrame>
        </div>

    )
}
